// eslint-disable-next-line no-restricted-imports
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { assignInlineVars } from "@vanilla-extract/dynamic";
import range from "lodash/range";
import * as React from "react";
import * as styles from "@faire/retailer-visitor-shared/components/SearchProducts/SingleProductRowPlaceholder/styles.css";
export var ROWS_PER_BATCH = 2;
export var SingleProductRowPlaceholder = function(param) {
    var itemsPerRowResponsive = param.itemsPerRowResponsive;
    var _itemsPerRowResponsive_tabletAndAbove, _itemsPerRowResponsive_desktopAndAbove;
    var _obj;
    var vars = assignInlineVars((_obj = {}, _define_property(_obj, styles.mobileColumnsVar, String(itemsPerRowResponsive.mobileAndAbove + 1)), _define_property(_obj, styles.tabletColumnsVar, String(((_itemsPerRowResponsive_tabletAndAbove = itemsPerRowResponsive.tabletAndAbove) !== null && _itemsPerRowResponsive_tabletAndAbove !== void 0 ? _itemsPerRowResponsive_tabletAndAbove : 2) + 1)), _define_property(_obj, styles.desktopColumnsVar, String(((_itemsPerRowResponsive_desktopAndAbove = itemsPerRowResponsive.desktopAndAbove) !== null && _itemsPerRowResponsive_desktopAndAbove !== void 0 ? _itemsPerRowResponsive_desktopAndAbove : 5) + 1)), _obj));
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: range(ROWS_PER_BATCH).map(function(value) {
            return /*#__PURE__*/ _jsx("div", {
                className: styles.rowPlaceholderWrapper,
                style: vars,
                "data-test-id": "single-row-placeholder-".concat(value)
            }, value);
        })
    });
};
